// FETCH ALL GENERAL_PO
export const FETCH_GENERAL_DC_MASTER_REQUEST = 'FETCH_GENERAL_DC_MASTER_REQUEST';
export const FETCH_GENERAL_DC_MASTER_SUCCESS = 'FETCH_GENERAL_DC_MASTER_SUCCESS';
export const FETCH_GENERAL_DC_MASTER_FAILURE = 'FETCH_GENERAL_DC_MASTER_FAILURE';

// CREATE GENERAL_PO
export const CREATE_GENERAL_DC_MASTER_REQUEST = 'CREATE_GENERAL_DC_MASTER_REQUEST';
export const CREATE_GENERAL_DC_MASTER_SUCCESS = 'CREATE_GENERAL_DC_MASTER_SUCCESS';
export const CREATE_GENERAL_DC_MASTER_FAILURE = 'CREATE_GENERAL_DC_MASTER_FAILURE';

// UPDATE GENERAL_PO
export const UPDATE_GENERAL_DC_MASTER_REQUEST = 'UPDATE_GENERAL_DC_MASTER_REQUEST';
export const UPDATE_GENERAL_DC_MASTER_SUCCESS = 'UPDATE_GENERAL_DC_MASTER_SUCCESS';
export const UPDATE_GENERAL_DC_MASTER_FAILURE = 'UPDATE_GENERAL_DC_MASTER_FAILURE';

// FETCH SINGLE STATE OF GENERAL_PO
export const FETCH_SINGLE_GENERAL_DC_MASTER_REQUEST = 'FETCH_SINGLE_GENERAL_DC_MASTER_REQUEST';
export const FETCH_SINGLE_GENERAL_DC_MASTER_SUCCESS = 'FETCH_SINGLE_GENERAL_DC_MASTER_SUCCESS';
export const FETCH_SINGLE_GENERAL_DC_MASTER_FAILURE = 'FETCH_SINGLE_GENERAL_DC_MASTER_FAILURE';

// DELETE GENERAL_PO
export const DELETE_GENERAL_DC_MASTER_REQUEST = 'DELETE_GENERAL_DC_MASTER_REQUEST';
export const DELETE_GENERAL_DC_MASTER_SUCCESS = 'DELETE_GENERAL_DC_MASTER_SUCCESS';
export const DELETE_GENERAL_DC_MASTER_FAILURE = 'DELETE_GENERAL_DC_MASTER_FAILURE';

export const RESET_GENERAL_DC_MASTER_INFO = 'RESET_GENERAL_DC_MASTER_INFO';

export const CREATE_GENERAL_DC_MASTER_FORM = 'CREATE_GENERAL_DC_MASTER_FORM';

export const UPDATE_GENERAL_DC_MASTER_FORM = 'UPDATE_GENERAL_DC_MASTER_FORM';

// NAVIGATE TO PARTY DETAILS COMPONENT
export const NAVIGATE_GENERAL_DC_DETAILS = 'NAVIGATE_GENERAL_DC_DETAILS';

// NAVIGATE TO GENERAL_PO COMPONENT
export const NAVIGATE_GENERAL_DC_MASTER = 'NAVIGATE_GENERAL_DC_MASTER';


export const FETCH_GENERAL_DC_MASTER_INVOICE_REQUEST = 'FETCH_GENERAL_DC_MASTER_INVOICE_REQUEST';
export const FETCH_GENERAL_DC_MASTER_INVOICE_SUCCESS = 'FETCH_GENERAL_DC_MASTER_INVOICE_SUCCESS';
export const FETCH_GENERAL_DC_MASTER_INVOICE_FAILURE = 'FETCH_GENERAL_DC_MASTER_INVOICE_FAILURE';

export const RESET_GENERAL_DC_MASTER_INVOICE = 'RESET_GENERAL_DC_MASTER_INVOICE';

export const GENERAL_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE = 'GENERAL_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE';

export const NAVIGATE_TO_DETAIL_TAB = 'NAVIGATE_TO_DETAIL_TAB'

export const DELETE_BTN_UPDATE_API_REQUEST = 'DELETE_BTN_UPDATE_API_REQUEST';
export const DELETE_BTN_UPDATE_API_SUCCESS = 'DELETE_BTN_UPDATE_API_SUCCESS';
export const DELETE_BTN_UPDATE_API_FAILURE = 'DELETE_BTN_UPDATE_API_FAILURE';

export const CLOSE_BTN_POST_REQUEST_GENERAL_DC = 'CLOSE_BTN_POST_REQUEST_GENERAL_DC'
export const CLOSE_BTN_POST_SUCCESS_GENERAL_DC = 'CLOSE_BTN_POST_SUCCESS_GENERAL_DC'
export const CLOSE_BTN_POST_FAILURE_GENERAL_DC = 'CLOSE_BTN_POST_FAILURE_GENERAL_DC'

export const CHECK_ALL_UPDATE_REQUEST_GENERAL_DC = 'CHECK_ALL_UPDATE_REQUEST_GENERAL_DC';
export const CHECK_ALL_UPDATE_SUCCESS_GENERAL_DC = 'CHECK_ALL_UPDATE_SUCCESS_GENERAL_DC';
export const CHECK_ALL_UPDATE_FAILURE_GENERAL_DC = 'CHECK_ALL_UPDATE_FAILURE_GENERAL_DC';

export const HEADER_SEARCH_CALL_ONLOAD = 'HEADER_SEARCH_CALL_ONLOAD';

export const NAVIGATE_GENERAL_DC_MASTER_PRINT = 'NAVIGATE_GENERAL_DC_MASTER_PRINT';

export const SET_RETURNABLE_GRID_NAME_GENERAL_DC_HEADER = 'SET_RETURNABLE_GRID_NAME_GENERAL_DC_HEADER';

export const FETCH_SAMPLE_DC_PROGRAM_LIST_REQUEST = 'FETCH_SAMPLE_DC_PROGRAM_LIST_REQUEST';
export const FETCH_SAMPLE_DC_PROGRAM_LIST_SUCCESS = 'FETCH_SAMPLE_DC_PROGRAM_LIST_SUCCESS';
export const FETCH_SAMPLE_DC_PROGRAM_LIST_FAILURE = 'FETCH_SAMPLE_DC_PROGRAM_LIST_FAILURE';

export const FETCH_WASTE_DC_COMPLETED_STATUS_REQUEST = 'FETCH_WASTE_DC_COMPLETED_STATUS_REQUEST';
export const FETCH_WASTE_DC_COMPLETED_STATUS_SUCCESS = 'FETCH_WASTE_DC_COMPLETED_STATUS_SUCCESS';
export const FETCH_WASTE_DC_COMPLETED_STATUS_FAILURE = 'FETCH_WASTE_DC_COMPLETED_STATUS_FAILURE';